import React, {Component} from "react";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";

import Login from "./Pages/Global/Login.js";
import Profile from "./Pages/Global/Profile.js";
import StudentMain from "./Pages/Student/Main";
import Vocab from "./Pages/Student/Vocab";
import VocabHomework from "./Pages/Student/Homework/VocabHomework";
import VocabExam from "./Pages/Student/Exam";
import VocabExamResult from "./Pages/Student/Exam/Result";
import Calendar from "./Pages/Student/Calendar";

import PageNotFound404 from "./Pages/Common/404";
import * as CookieService from "../services/Cookie/CookieService";
import * as Utils from "./Utils";

import AdminMain from "./Pages/Teacher/AdminMain";
import AdminSetting from "./Pages/Teacher/AdminSetting";
import AdminSystem from "./Pages/Teacher/AdminSystem";
import AdminManagement from "./Pages/Teacher/AdminManagement";
import Online from "./Pages/Online";
import Reading from "./Pages/Student/Reading";
import ReadingHomework from "./Pages/Student/Homework/ReadingHomework";

import AttendanceMain from "./Pages/Attendance/AttendanceMain";
import AttendanceManagement from "./Pages/Attendance/AttendanceManagement";

class App extends Component {
    render() {
        /** Cookie 값 체크 */
        if (!Utils.isConnectedLocalServer() && CookieService.hasCookie() === false && document.location.pathname !== '/app/login') {
            return <Redirect to="/app/login"/>
        }
        /** Cookie Validation */
        if (CookieService.hasCookie() === false && document.location.pathname !== '/app/login') {
            return <Redirect to='/app/login'/>
        } else if (CookieService.isCookieValidate() === true
            && (document.location.pathname === '/app/login' || document.location.pathname === '/app' || document.location.pathname === '/')) {
            if (Utils.getIdentityFromCookie() === 'I_STUDENT') {
                return <Redirect to='/app/homework'/>
            } else if (Utils.getIdentityFromCookie() === 'I_TEACHER' || Utils.getIdentityFromCookie() === 'I_ADMIN' || Utils.getIdentityFromCookie() === 'I_BEACON') {
                return <Redirect to='/app/teacher'/>
            } else if (Utils.getIdentityFromCookie() === 'I_ATTENDANCE') {
                return <Redirect to='/app/attendance'/>
            } else {
                return <Redirect to='/app/login'/>
            }
        }

        const ErrorUrl = () => {
            return (
                <div>
                    {/*error*/}
                    <Route component={PageNotFound404}/>
                </div>
            );
        }
        const DefaultUrl = () => {
            return (
                <Switch>
                    {/*common*/}
                    <Route exact path="/">
                        <Redirect to="/app/login" />
                    </Route>
                    <Route exact path="/app">
                        <Redirect to="/app/login" />
                    </Route>
                    <Route path="/app/login" component={Login}/>
                    <ErrorUrl/>
                </Switch>
            );
        }
        const AuthUrl = () => {
            if (Utils.getIdentityFromCookie() === 'I_STUDENT') {
                return (
                    <Switch>
                        {/*student*/}
                        <Route path="/app/homework" component={StudentMain}/>
                        <Route path="/app/vocabulary" component={Vocab}/>
                        <Route path="/app/vocabhomework" component={VocabHomework}/>
                        <Route path="/app/vocabexam" component={VocabExam}/>
                        <Route path="/app/vocabexamresult" component={VocabExamResult}/>
                        <Route path="/app/reading" component={Reading}/>
                        <Route path="/app/readinghomework" component={ReadingHomework}/>
                        <Route path="/app/calendar" component={Calendar}/>
                        <Route path="/app/profile" component={Profile}/>
                        <Route path="/app/online" component={Online}/>
                        <DefaultUrl/>
                    </Switch>
                );
            }
            if (Utils.getIdentityFromCookie() === 'I_TEACHER' || Utils.getIdentityFromCookie() === 'I_ADMIN' || Utils.getIdentityFromCookie() === 'I_BEACON') {
                return (
                    <Switch>
                        {/*teacher*/}
                        <Route path="/app/teacher" component={AdminMain}/>
                        <Route path="/app/management" component={AdminManagement}/>
                        <Route path="/app/setting" component={AdminSetting}/>
                        <Route path="/app/system" component={AdminSystem}/>
                        <Route path="/app/profile" component={Profile}/>
                        <DefaultUrl/>
                    </Switch>
                );
            }
            if (Utils.getIdentityFromCookie() === 'I_ATTENDANCE') {
                return (
                    <Switch>
                        {/*attendance*/}
                        <Route path="/app/attendance" component={AttendanceMain}/>
                        <Route path="/app/management" component={AttendanceManagement}/>
                        <Route path="/app/profile" component={Profile}/>
                        <DefaultUrl/>
                    </Switch>
                );
            }
            return (
                <DefaultUrl/>
            );
        }

        return (
            <React.Fragment>
                <Router>
                    <React.Fragment>
                        <AuthUrl/>
                    </React.Fragment>
                </Router>
            </React.Fragment>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js